import * as React from "react";
import * as BS from "react-bootstrap";
import { AlertTitle, AlertType } from "../../models/alert";
import { Icon } from ".";

type OwnProps = React.HTMLAttributes<any> & {
    dismissHandler?: () => void;
    icon?: string;
    title?: AlertTitle;
    type?: AlertType;
    show?: boolean;
};

interface OwnState {
}

export class Alert extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
    }

    public handleDismiss = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (this.props.dismissHandler)
            this.props.dismissHandler();

        e.preventDefault();
        return false;
    }

    public render() {
        if (this.props.show !== undefined && !this.props.show)
            return null;

        const iconEl = this.props.icon
            ? <Icon icon={this.props.icon} />
            : null;

        const titleEl = this.props.title
            ? (typeof this.props.title === "string"
                ? <strong>{iconEl}{(this.props.icon ? " " : "") + this.props.title}</strong>
                : this.props.title)
            : null;

        return <BS.Alert bsStyle={this.props.type || "info"} onDismiss={this.props.dismissHandler}>
            {titleEl}
            {typeof this.props.children === "string"
                ? <div dangerouslySetInnerHTML={{ __html: this.props.children }} />
                : this.props.children}
        </BS.Alert>;
    }
}

interface ErrorAlertProps {
    dismissHandler?: () => void;
    errors?: string[];
    title?: string;
}

export const ErrorAlert: React.SFC<ErrorAlertProps> = (props) => {
    return <Alert
        dismissHandler={props.dismissHandler}
        show={props.errors !== undefined && props.errors.length > 0}
        title={props.title || "An error occurred"}
        type="danger"
    >
        <ul>
            {(props.errors || []).map((e, i) => <li key={i}>{e}</li>)}
        </ul>
    </Alert>;
};



// WEBPACK FOOTER //
// ./src/components/generic/Alert.tsx